import { BeconCommonTypes } from "@becon-team/becon-fe-lib/my-types";
import { i18n as I18nType } from "i18next";
const commonPrefix = "/assets/images/common";
export const commonAssets = {
  logo: {
    default: commonPrefix + "/logo/default.webp",
  },
  loading: {
    scalp_macro: commonPrefix + "/loading/scalp_macro.gif",
    scalp_micro: commonPrefix + "/loading/scalp_micro.gif",
    skin_macro: commonPrefix + "/loading/skin_macro.gif",
    skin_micro: commonPrefix + "/loading/skin_micro.gif",
  },
  scanner: {
    connect: commonPrefix + "/scanner/connect.webp",
    disconnect: commonPrefix + "/scanner/disconnect.webp",
    scanner: commonPrefix + "/scanner/scanner.webp",
  },
};

const introPrefix = "/assets/images/intro";
export const introAssets = {
  scalp_macro: introPrefix + "/scalp_macro.webp",
  scalp_forehead: introPrefix + "/scalp_forehead.webp",
  scalp_micro: introPrefix + "/scalp_micro.webp",
  skin_face: introPrefix + "/skin_face.webp",
  skin_macro: introPrefix + "/skin_macro.webp",
  skin_micro_2: introPrefix + "/skin_micro_2.webp",
  skin_micro: introPrefix + "/skin_micro.webp",
};

const weatherPrefix = "/assets/images/weather";
export const weatherAssets = {
  sun: weatherPrefix + "/sun.webp",
};

const skinPrefix = "/assets/images/skin";
export const skinAssets = {
  demo: {
    micro_1: skinPrefix + "/demo/micro_1.webp",
    micro_2: skinPrefix + "/demo/micro_2.webp",
    micro_3: skinPrefix + "/demo/micro_3.webp",
    micro_4: skinPrefix + "/demo/micro_4.webp",
    micro_5: skinPrefix + "/demo/micro_5.webp",
    micro_6: skinPrefix + "/demo/micro_6.webp",
  },
  skin_macro_contents_1: skinPrefix + "/skin-macro-contents-1.webp",
  skin_micro_contents_1: skinPrefix + "/skin-micro-contents-1.webp",
  square: {
    bad: skinPrefix + "/square/bad.webp",
    normal: skinPrefix + "/square/normal.webp",
  },
};

const scalpPrefix = "/assets/images/scalp";
export const scalpAssets = {
  etc: {
    forehead_shadow: scalpPrefix + "/etc/forehead_shadow.webp",
    hair_loss: scalpPrefix + "/etc/hair_loss.webp",
  },
  crown: scalpPrefix + "/crown.webp",
  crown_analysis: scalpPrefix + "/crown-analysis.webp",
  forehead: scalpPrefix + "/forehead.webp",
  forehead_contents_1: scalpPrefix + "/forehead-contents-1.webp",
  forehead_contents_2: scalpPrefix + "/forehead-contents-2.webp",
};

const scannerPrefix = "/assets/images/common/scanner";
export const scannerAssets = {
  b2c_scanner: scannerPrefix + "/b2c_scanner.webp",
  connect: scannerPrefix + "/connect.webp",
  disconnect: scannerPrefix + "/disconnect.webp",
  scanner: scannerPrefix + "/scanner.webp",
};

export const introStepPrefix = "/assets/images/intro-step";
export const getIntroStepImage = ({ i18n, stepNumber }: { i18n: I18nType; stepNumber: number }): string => {
  const primaryLanguage = i18n.languages[0].toLowerCase();
  const languageMap: { [key: string]: { [step: number]: string } } = {
    ko: {
      1: "scalp_ko_1.webp",
    },
    ja: {
      1: "scalp_ja_1.webp",
    },
    en: {
      1: "scalp_en_1.webp",
    },
  };
  const stepImages = languageMap[primaryLanguage] || languageMap["en"];
  const imageName = stepImages[stepNumber] || stepImages[1]; // 기본적으로 1단계 이미지 fallback
  return `${introStepPrefix}/${imageName}`;
};

export const mainPrefix = "/assets/images/main/banner";
export const getMainImageSwiper = ({ i18n }: { i18n: I18nType }) => {
  const primaryLanguage = i18n.languages[0].toLowerCase();
  const languageMap: { [key: string]: { url: string; id: number }[] } = {
    ko: [
      { url: `${mainPrefix}/shampoo_kr_1.png`, id: 1 },
      { url: `${mainPrefix}/forehead_kr_2.png`, id: 2 },
      { url: `${mainPrefix}/device_kr_3.png`, id: 3 },
    ],
    ja: [
      { url: `${mainPrefix}/shampoo_jp_1.png`, id: 1 },
      { url: `${mainPrefix}/forehead_jp_2.png`, id: 2 },
      { url: `${mainPrefix}/device_jp_3.png`, id: 3 },
    ],
    en: [
      { url: `${mainPrefix}/shampoo_en_1.png`, id: 1 },
      { url: `${mainPrefix}/forehead_en_2.png`, id: 2 },
      { url: `${mainPrefix}/device_en_3.png`, id: 3 },
    ],
  };
  return languageMap[primaryLanguage] || languageMap["en"];
};

export const bigDataPrefix = "/assets/images/bigData";
export const getBigDataImage = ({ i18n }: { i18n: I18nType }): string => {
  const primaryLanguage = i18n.languages[0].toLowerCase();
  const languageMap: { [key: string]: string } = {
    ko: "kr.png",
    en: "en.png",
    ja: "jp.png",
  };
  const bigDataImg = languageMap[primaryLanguage] || languageMap["en"];
  return `${bigDataPrefix}/${bigDataImg}`;
};

export const shampooMatchingPrefix = "/assets/images/shampoo/matching";
export const getShampooMatching = ({ i18n }: { i18n: I18nType }): string => {
  const primaryLanguage = i18n.languages[0].toLowerCase();
  const languageMap: { [key: string]: string } = {
    ko: "kr.png",
    en: "en.png",
    ja: "jp.png",
  };
  const shampooMatchingImg = languageMap[primaryLanguage] || languageMap["en"];
  return `${shampooMatchingPrefix}/${shampooMatchingImg}`;
};

export const foreheadPrefix = "/assets/images/forehead";
export const getForeheadImage = ({ i18n }: { i18n: I18nType }): string => {
  const primaryLanguage = i18n.languages[0].toLowerCase();
  const languageMap: { [key: string]: string } = {
    ko: "kr.png",
    en: "en.png",
    ja: "jp.png",
  };
  const foreheadImg = languageMap[primaryLanguage] || languageMap["en"];
  return `${foreheadPrefix}/${foreheadImg}`;
};

export const challengePrefix = "/assets/images/challenge";
export const getChallengeImage = ({ region }: { region: BeconCommonTypes.Region }): string => {
  const regionMap: { [key: string]: string } = {
    KR: "kr.png",
    EN: "en.png",
    JP: "jp.png",
  };
  const challengeImg = regionMap[region] || regionMap["EN"];
  return `${challengePrefix}/${challengeImg}`;
};

export const headerPrefix = "/assets/images/header";
export const getScannerStatusImage = (isScannerConnected: boolean): string => {
  const deviceImg = isScannerConnected ? "scanner_connected.webp" : "scanner_unconnected.webp";

  return `${headerPrefix}/${deviceImg}`;
};

const companyPrefix = "/assets/images/company";
export const companyAssets = {
  category: {
    HOSPITAL: companyPrefix + "/category/hospital.webp",
    SALON: companyPrefix + "/category/salon.webp",
    CLINIC: companyPrefix + "/category/clinic.webp",
    SMP: companyPrefix + "/category/smp.webp",
    HNB: companyPrefix + "/category/clinic.webp",
    BRAND: companyPrefix + "/category/clinic.webp",
  },
};
